import { Flex } from 'antd'
import { createStyles } from 'antd-style'

const useStyles = createStyles(({ token }) => ({
  triangular: {
    width: 7,
    height: 4,
    borderInline: `4px solid transparent`,
    borderBlockEnd: `8px solid currentColor`
  },
  square: {
    width: 3,
    height: 8,
    background: 'currentColor'
  },
  text: {
    paddingInlineStart: token.paddingXS,
    fontSize: token.fontSizeHeading5
  }
}))

export const UpDownTag = ({
  ranking,
  isUp
}: {
  ranking: number
  isUp?: boolean
}) => {
  const { theme, styles } = useStyles({ isUp: !!isUp })
  return ranking > 0 ? (
    <Flex
      align='center'
      style={{
        color: isUp ? theme.blue : theme.red
      }}
    >
      <Flex
        vertical
        align='center'
        justify='center'
        style={{
          transform: isUp ? 'rotate(0deg)' : 'rotate(180deg)'
        }}
      >
        <div className={styles.triangular} />
        <div className={styles.square} />
      </Flex>
      <div className={styles.text}>{ranking}</div>
    </Flex>
  ) : null
}
